import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@suiet/wallet-kit/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WalletProvider } from "@suiet/wallet-kit";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WalletProvider>
      <App />
    </WalletProvider>
  </React.StrictMode>
);

reportWebVitals();